import { render, staticRenderFns } from "./TrustBookings.vue?vue&type=template&id=277ad9c0"
import script from "./TrustBookings.vue?vue&type=script&lang=js"
export * from "./TrustBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports